import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '@/HomePage.vue';
import ProfilePage from '@/ProfilePage.vue';
import PostPage from '@/PostPage.vue';
import GalleryPage from '@/GalleryPage.vue';
import AboutPage from '@/AboutPage.vue';
import ContactPage from '@/ContactPage.vue';

const router = createRouter({
  history: createWebHistory(), // Use HTML5 history mode
  routes: [
    {
      path: '/',
      name: 'index',
      component: HomePage,
    },
    {
      path: '/gallery',
      name: 'gallery',
      component: GalleryPage,
    },
    {
      path: '/about',
      name: 'about',
      component: AboutPage,
    },
    {
      path: '/contact',
      name: 'contact',
      component: ContactPage,
    },
    {
      path: '/profile/:id',
      name: 'ProfilePage',
      component: ProfilePage,
      props: true  // This will pass the user ID as a prop
    },
    {
    path: '/post/a/:id',
    name: 'PostPage',
    component: PostPage,
    props: true  // This will pass the post ID as a prop
    },
  ],
});

export default router;